<template>
  <div id="modal-bm">
		<div class="modal" :class="{ 'is-active': toggle }">
      <div class="modal-background"></div>
			<div class="modal-content px-2" :class="{ 'no-padding': fullscreen }">
				<slot></slot>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "BModal",
  props: {
    fullscreen: {
      type: Boolean,
      required: false,
			default: false,
    },
		toggle: {
      type: Boolean,
      required: true,
    },
  },
	setup(_, ctx) {
		function onCloseClick() {
			ctx.emit('on-close-click')
		}
		return { onCloseClick }
	}
  // type inference enabled
});
</script>

<style lang="stylus" scoped>
@keyframes  openingModalAnim {
  from {
    transform: scale3d(0.0,0.0,0.0)
  }
}

.no-padding
	max-height none
	padding-right: 0px !important
	padding-left: 0px !important
.is-active .modal-content
  animation openingModalAnim .5s ease

</style>
